"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mapProductData;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _imagesNew = _interopRequireDefault(require("@deosite/mock-data/images-new"));
var _checkIfSpecialPriceIsActive = _interopRequireDefault(require("../checkIfSpecialPriceIsActive"));
var _getAttribute = _interopRequireDefault(require("../getAttribute"));
var _getMainCategoryId = _interopRequireDefault(require("./getMainCategoryId"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapProduct = function mapProduct(data, differentiators) {
  var _data$extension_attri, _data$extension_attri2, _data$extension_attri3, _data$extension_attri4, _data$custom_attribut, _data$extension_attri5, _data$extension_attri6, _data$extension_attri7, _data$product_links, _data$extension_attri8, _data$extension_attri9, _data$extension_attri10, _data$extension_attri11, _data$extension_attri12, _ref2, _firstImageBlur$filen, _data$extension_attri13, _data$extension_attri14, _firstImageBlur$filen2, _data$extension_attri15, _data$extension_attri16;
  var customAttributes = (0, _getAttribute["default"])(data.custom_attributes);
  var hasSpecialPrice = (0, _checkIfSpecialPriceIsActive["default"])(customAttributes("special_from_date")("value"), customAttributes("special_to_date")("value"));
  var specialPrice = function specialPrice(hasSpecialPrice, _specialPrice) {
    return !hasSpecialPrice ? null : _specialPrice ? parseFloat(_specialPrice) : null;
  };
  var getBlurAndFileNameImage = function getBlurAndFileNameImage(imageFile) {
    var _imageFound$extension2, _imageFound$extension3;
    if (!imageFile) {
      return;
    }
    var imageFileNew = imageFile.replace("media/catalog/product/", "");
    var imageFound = data.media_gallery_entries.find(function (image) {
      return image.file === imageFileNew;
    });
    if (!imageFound || !(imageFound !== null && imageFound !== void 0 && imageFound.extension_attributes)) {
      return;
    }
    imageFileNew = imageFileNew.replace(/([^\/]+)$/, "$width/");
    var _imageFound$extension = imageFound === null || imageFound === void 0 ? void 0 : imageFound.extension_attributes,
      blurhash = _imageFound$extension.blurhash,
      filename = _imageFound$extension.filename;
    return {
      blurhash: blurhash,
      filename: parseInt(imageFound === null || imageFound === void 0 ? void 0 : (_imageFound$extension2 = imageFound.extension_attributes) === null || _imageFound$extension2 === void 0 ? void 0 : _imageFound$extension2.servlocal) ? imageFileNew + filename : imageFile,
      servlocal: parseInt(imageFound === null || imageFound === void 0 ? void 0 : (_imageFound$extension3 = imageFound.extension_attributes) === null || _imageFound$extension3 === void 0 ? void 0 : _imageFound$extension3.servlocal)
    };
  };
  var dajarCollection = customAttributes("dajar_collection");
  var availability = customAttributes("availability");
  var producer = customAttributes("producer")("name");
  var producerId = customAttributes("producer")("value");
  var pickedOptions = differentiators ? data.custom_attributes.filter(function (attribute) {
    var _attribute$attribute_;
    return differentiators.includes((_attribute$attribute_ = attribute === null || attribute === void 0 ? void 0 : attribute.attribute_code) !== null && _attribute$attribute_ !== void 0 ? _attribute$attribute_ : attribute.label);
  }).map(function (attribute) {
    if (attribute.attribute_code === "capacity") {
      return _objectSpread(_objectSpread({}, attribute), {}, {
        name: (parseInt(attribute.name) / 1000).toString()
      });
    }
    return attribute;
  }) : [];
  var mapOptionImage = function mapOptionImage(image) {
    if (image !== null && image !== void 0 && image.extension_attributes) {
      var imageBlur = getBlurAndFileNameImage(image.file);
      var url = imageBlur !== null && imageBlur !== void 0 && imageBlur.servlocal ? "".concat(imageBlur.filename) : "/media/catalog/product".concat(imageBlur.filename);
      return {
        altText: "image",
        originalSrc: url,
        blurhash: imageBlur.blurhash,
        variants: [{
          name: "natural",
          aspectRatio: 1,
          srcset: [{
            url: url,
            w: 50,
            h: 50
          }]
        }]
      };
    }
    return {
      altText: "image",
      originalSrc: "/media/catalog/product".concat(image.file),
      variants: [{
        name: "natural",
        aspectRatio: 1,
        srcset: [{
          url: "/media/catalog/product".concat(image.file),
          w: 50,
          h: 50
        }]
      }]
    };
  };
  var findOptionPickerImage = function findOptionPickerImage(imagesArray) {
    if ((imagesArray === null || imagesArray === void 0 ? void 0 : imagesArray.length) === 0) return;
    var swatchImage = false;
    imagesArray.find(function (image) {
      if (image.types.includes("swatch_image")) {
        swatchImage = mapOptionImage(image, true);
      }
    });
    !swatchImage && imagesArray.find(function (image) {
      if (image.types.includes("allegro_image")) {
        swatchImage = mapOptionImage(image);
      }
    });
    if (swatchImage) return swatchImage;
    return mapOptionImage(imagesArray[0]);
  };
  var firstImageBlur = (_data$extension_attri = data.extension_attributes) !== null && _data$extension_attri !== void 0 && (_data$extension_attri2 = _data$extension_attri.image_dimensions[0]) !== null && _data$extension_attri2 !== void 0 && _data$extension_attri2.product_page_image_medium ? getBlurAndFileNameImage((_data$extension_attri3 = data.extension_attributes.image_dimensions[0].product_page_image_medium) === null || _data$extension_attri3 === void 0 ? void 0 : _data$extension_attri3.src) : _imagesNew["default"].no_image;
  if (((_data$extension_attri4 = data.extension_attributes.ean) === null || _data$extension_attri4 === void 0 ? void 0 : _data$extension_attri4.length) > 0) {
    data.custom_attributes.push({
      attribute_code: "ean",
      name: data.extension_attributes.ean
    });
  }
  var findImageByType = function findImageByType(imageToCheck, imagesData) {
    var _imageToCheck$product, _imageToCheck$product2, _imageToCheck$product3, _finalImage$types;
    var imageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "allegro_image";
    if (!(imageToCheck !== null && imageToCheck !== void 0 && imageToCheck.product_page_image_medium)) {
      return false;
    }
    var imagePath = (_imageToCheck$product = imageToCheck.product_page_image_medium) === null || _imageToCheck$product === void 0 ? void 0 : (_imageToCheck$product2 = _imageToCheck$product.src) === null || _imageToCheck$product2 === void 0 ? void 0 : (_imageToCheck$product3 = _imageToCheck$product2.split("/product")) === null || _imageToCheck$product3 === void 0 ? void 0 : _imageToCheck$product3.pop();
    var finalImage = imagesData.find(function (image) {
      return image.file === imagePath;
    });
    return finalImage === null || finalImage === void 0 ? void 0 : (_finalImage$types = finalImage.types) === null || _finalImage$types === void 0 ? void 0 : _finalImage$types.includes(imageType);
  };
  var productImages;
  if (data.extension_attributes.image_dimensions.length) {
    productImages = data.extension_attributes.image_dimensions.map(function (image) {
      var _image$product_page_i, _ref, _imageBlur$filename, _image$product_page_i2, _images$no_image, _imageBlur$filename2, _image$product_page_i3, _image$product_page_i4, _image$product_page_i5;
      var imageBlur = image !== null && image !== void 0 && image.product_page_image_medium ? getBlurAndFileNameImage((_image$product_page_i = image.product_page_image_medium) === null || _image$product_page_i === void 0 ? void 0 : _image$product_page_i.src) : null;
      return {
        allegroImage: findImageByType(image, data.media_gallery_entries, "allegro_image"),
        arrangedImage: findImageByType(image, data.media_gallery_entries, "arranged_image"),
        altText: data.name,
        originalSrc: (_ref = (_imageBlur$filename = imageBlur === null || imageBlur === void 0 ? void 0 : imageBlur.filename) !== null && _imageBlur$filename !== void 0 ? _imageBlur$filename : image === null || image === void 0 ? void 0 : (_image$product_page_i2 = image.product_page_image_medium) === null || _image$product_page_i2 === void 0 ? void 0 : _image$product_page_i2.src) !== null && _ref !== void 0 ? _ref : (_images$no_image = _imagesNew["default"].no_image) === null || _images$no_image === void 0 ? void 0 : _images$no_image.originalSrc,
        blurhash: imageBlur === null || imageBlur === void 0 ? void 0 : imageBlur.blurhash,
        variants: image !== null && image !== void 0 && image.product_page_image_medium ? [{
          name: "natural",
          aspectRatio: 1,
          srcset: [{
            url: (_imageBlur$filename2 = imageBlur === null || imageBlur === void 0 ? void 0 : imageBlur.filename) !== null && _imageBlur$filename2 !== void 0 ? _imageBlur$filename2 : (_image$product_page_i3 = image.product_page_image_medium) === null || _image$product_page_i3 === void 0 ? void 0 : _image$product_page_i3.src,
            w: (_image$product_page_i4 = image.product_page_image_medium) === null || _image$product_page_i4 === void 0 ? void 0 : _image$product_page_i4.width,
            h: (_image$product_page_i5 = image.product_page_image_medium) === null || _image$product_page_i5 === void 0 ? void 0 : _image$product_page_i5.height
          }]
        }] : _imagesNew["default"].no_image.variants
      };
    });
    productImages.find(function (image, index) {
      if (image.pdpDefault) {
        productImages.splice(index, 1);
        productImages.unshift(image);
      }
    });
  } else {
    productImages = [_objectSpread({
      altText: data.name
    }, _imagesNew["default"].no_image)];
  }
  var attributes = ((_data$custom_attribut = data.custom_attributes) === null || _data$custom_attribut === void 0 ? void 0 : _data$custom_attribut[0]) && data.custom_attributes;
  var technicalData = [];
  var productWeight = (_data$extension_attri5 = data.extension_attributes) === null || _data$extension_attri5 === void 0 ? void 0 : _data$extension_attri5.weight_net;
  if (attributes) {
    var technicalDataNamesOrder = ["brand", "producer", "dajar_collection", "diameter", "capacity", "length", "width", "height", "depth", "thickness", "weight", "max_load", "number_of_people", "material", "composition", "application", "feature", "color_list", "pattern_list", "country_of_origin",
    // nie wiem czy taki jest kod, nie kojarze tego
    "ean"];
    technicalDataNamesOrder.map(function (dataName) {
      if (dataName !== "weight") {
        var attribute = attributes === null || attributes === void 0 ? void 0 : attributes.find(function (attribute) {
          return attribute.attribute_code === dataName;
        });
        technicalData.push({
          label: dataName,
          name: attribute === null || attribute === void 0 ? void 0 : attribute.name
        });
        return;
      }
      technicalData.push({
        label: "weight",
        name: productWeight
      });
    });
  } else {
    productWeight && technicalData.push({
      label: "weight",
      name: productWeight
    });
  }
  var productCategoryIdList = (_data$extension_attri6 = data.extension_attributes) === null || _data$extension_attri6 === void 0 ? void 0 : (_data$extension_attri7 = _data$extension_attri6.category_links) === null || _data$extension_attri7 === void 0 ? void 0 : _data$extension_attri7.map(function (category) {
    return parseInt(category.category_id);
  });
  return {
    name: data.name,
    id: data.id,
    sku: data.sku,
    url: data.url_key,
    isNew: checkIfNew(data.category_paths),
    promoLabelIndex: checkPromotionsLabelIndex(data.category_paths),
    price: {
      regular: data.price,
      special: specialPrice(hasSpecialPrice, customAttributes("special_price")("value")),
      lowest: customAttributes("lowest_price")("value")
    },
    relatedProducts: data === null || data === void 0 ? void 0 : (_data$product_links = data.product_links) === null || _data$product_links === void 0 ? void 0 : _data$product_links.map(function (productLink) {
      return {
        linkType: productLink.link_type,
        sku: productLink.linked_product_sku
      };
    }),
    labelText: customAttributes("opportunity")("name"),
    collection: {
      id: dajarCollection("value"),
      name: dajarCollection("name"),
      url: getUrlFromAttributeData(dajarCollection("data"), "value")
    },
    producer: producer,
    producerId: producerId,
    logo: {
      altText: customAttributes("brand")("name"),
      originalSrc: data.custom_attributes.filter(function (attribute) {
        return attribute.attribute_code === "brand";
      })[0] !== undefined ? data.custom_attributes.filter(function (attribute) {
        return attribute.attribute_code === "brand";
      }).map(function (option) {
        if (option.data.swatch_image === undefined) {
          return undefined;
        } else {
          return option.data.swatch_image.src;
        }
      })[0] : undefined,
      variants: [{
        name: "natural",
        aspectRatio: 1,
        srcset: [{
          url: data.custom_attributes.filter(function (attribute) {
            return attribute.attribute_code === "brand";
          })[0] !== undefined ? data.custom_attributes.filter(function (attribute) {
            return attribute.attribute_code === "brand";
          }).map(function (option) {
            if (option.data.swatch_image === undefined) {
              return undefined;
            } else {
              return option.data.swatch_image.src;
            }
          })[0] : undefined,
          w: 30,
          h: 20
        }]
      }]
    },
    info: {
      description: customAttributes("description")("value"),
      shortDescription: customAttributes("short_description")("value"),
      technicalData: technicalData
    },
    availability: {
      name: availability("name"),
      level: availability("value"),
      stock: availability("value") === null ? " " : availability("value") === 0 ? "out of stock" : "in stock",
      quantity: (_data$extension_attri8 = data.extension_attributes) === null || _data$extension_attri8 === void 0 ? void 0 : _data$extension_attri8.qty
    },
    category: {
      id: global.__appConfig__.appDomain === undefined || global.__appConfig__.appDomain.includes("dajar") ? ((_data$extension_attri9 = data.extension_attributes) === null || _data$extension_attri9 === void 0 ? void 0 : (_data$extension_attri10 = _data$extension_attri9.category_links) === null || _data$extension_attri10 === void 0 ? void 0 : _data$extension_attri10.length) > 0 && parseInt((_data$extension_attri11 = data.extension_attributes) === null || _data$extension_attri11 === void 0 ? void 0 : (_data$extension_attri12 = _data$extension_attri11.category_links) === null || _data$extension_attri12 === void 0 ? void 0 : _data$extension_attri12[0].category_id) : (0, _getMainCategoryId["default"])({
        idList: productCategoryIdList,
        paths: data.category_paths
      }),
      ids: productCategoryIdList,
      pathIds: categoryPathIds(data.category_paths),
      main: getMainCategory(data.category_paths)
    },
    images: productImages,
    image: data.extension_attributes.image_dimensions.length ? {
      altText: data.name,
      originalSrc: (_ref2 = (_firstImageBlur$filen = firstImageBlur === null || firstImageBlur === void 0 ? void 0 : firstImageBlur.filename) !== null && _firstImageBlur$filen !== void 0 ? _firstImageBlur$filen : (_data$extension_attri13 = data.extension_attributes) === null || _data$extension_attri13 === void 0 ? void 0 : (_data$extension_attri14 = _data$extension_attri13.image_dimensions[0]) === null || _data$extension_attri14 === void 0 ? void 0 : _data$extension_attri14.product_page_image_medium.src) !== null && _ref2 !== void 0 ? _ref2 : _imagesNew["default"].no_image.originalSrc,
      blurhash: firstImageBlur === null || firstImageBlur === void 0 ? void 0 : firstImageBlur.blurhash,
      variants: [{
        name: "natural",
        aspectRatio: 1,
        srcset: [{
          url: (_firstImageBlur$filen2 = firstImageBlur === null || firstImageBlur === void 0 ? void 0 : firstImageBlur.filename) !== null && _firstImageBlur$filen2 !== void 0 ? _firstImageBlur$filen2 : (_data$extension_attri15 = data.extension_attributes) === null || _data$extension_attri15 === void 0 ? void 0 : (_data$extension_attri16 = _data$extension_attri15.image_dimensions[0]) === null || _data$extension_attri16 === void 0 ? void 0 : _data$extension_attri16.product_page_image_medium.src,
          w: data.extension_attributes.image_dimensions[0] && data.extension_attributes.image_dimensions[0].product_page_image_medium.width,
          h: data.extension_attributes.image_dimensions[0] && data.extension_attributes.image_dimensions[0].product_page_image_medium.height
        }]
      }]
    } : _objectSpread({
      altText: data.name
    }, _imagesNew["default"].no_image),
    optionPickerImage: findOptionPickerImage(data.media_gallery_entries),
    isVisible: data.visibility !== 0 && data.visibility !== 1,
    pickedOptions: pickedOptions
  };
};
function mapProductData(productFamily, skipConfigurableProductObjects) {
  var differentiators = productFamily.extension_attributes ? productFamily.extension_attributes.configurable_product_options.map(function (item) {
    var _item$extension_attri, _item$extension_attri2;
    return (_item$extension_attri = item === null || item === void 0 ? void 0 : (_item$extension_attri2 = item.extension_attributes) === null || _item$extension_attri2 === void 0 ? void 0 : _item$extension_attri2.attribute_code) !== null && _item$extension_attri !== void 0 ? _item$extension_attri : item.label.toLowerCase();
  }) : [];
  if (skipConfigurableProductObjects) {
    return Array.isArray(productFamily) ? productFamily.map(function (data) {
      return mapProduct(data);
    }) : mapProduct(productFamily);
  }
  if (!productFamily) {
    return;
  }
  return productFamily.extension_attributes && productFamily.extension_attributes.configurable_product_objects ? productFamily.extension_attributes.configurable_product_objects.map(function (data) {
    return mapProduct(data, differentiators);
  }) : productFamily.map(function (data) {
    return mapProduct(data);
  });
}
var getUrlFromAttributeData = function getUrlFromAttributeData(attribute, valueKey) {
  return attribute ? attribute[valueKey] : null;
};
var getMainCategory = function getMainCategory(categoryPath) {
  if (categoryPath && categoryPath.length) {
    var categoriesId = categoryPath[0].path.match(/\d+/g);
    return categoriesId.length > 2 ? categoriesId[2] : global.__appConfig__.defaultCategoryIdForBestsellerProducts;
  }
  return global.__appConfig__.defaultCategoryIdForBestsellerProducts;
};
var categoryPathIds = function categoryPathIds(categoryPaths) {
  var reducer = function reducer(acc, current) {
    var currentNumbers = current.path.split("/").map(Number);
    return (0, _toConsumableArray2["default"])(new Set([].concat((0, _toConsumableArray2["default"])(acc), (0, _toConsumableArray2["default"])(currentNumbers))));
  };
  return categoryPaths.reduce(reducer, []);
};
var checkIfNew = function checkIfNew(categoryPath) {
  var isNew = false;
  categoryPath.map(function (singlePath) {
    singlePath.path.split("/").map(function (category) {
      if (category === global.__appConfig__.newProductsCategoryIdPL) {
        isNew = true;
      }
    });
  });
  return isNew;
};
var checkPromotionsLabelIndex = function checkPromotionsLabelIndex(categoryPath) {
  var _global$__appConfig__, _global$__appConfig__2;
  var currentHighestIndex;
  var promotionCategoriesArray = (_global$__appConfig__ = (_global$__appConfig__2 = global.__appConfig__.promotionCategoriesOrder) === null || _global$__appConfig__2 === void 0 ? void 0 : _global$__appConfig__2.split(",")) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : [];
  categoryPath.forEach(function (singlePath) {
    promotionCategoriesArray.forEach(function (categoryId, index) {
      if (singlePath.path.split("/").includes(categoryId)) {
        currentHighestIndex = currentHighestIndex === undefined ? index : currentHighestIndex < index ? currentHighestIndex : index;
      }
    });
  });
  return currentHighestIndex;
};